import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ExpertSystemEquipmentType, DailyKpiValue, DailyKpiValuesQueryKey} from '../types'

export const useDailyKpiValue = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  year: number,
  month: number,
  options?: Omit<
    UseQueryOptions<DailyKpiValue[], AxiosError, DailyKpiValue[]>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: [DailyKpiValuesQueryKey, kpiTargetEquipmentType, year, month],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<DailyKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/daily`,
        {
          params: {year, month},
          signal
        }
      )
      return response.data
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    ...options
  })
}
